import { render, staticRenderFns } from "./AddDiscount.vue?vue&type=template&id=aad078d2&"
import script from "./AddDiscount.vue?vue&type=script&lang=ts&"
export * from "./AddDiscount.vue?vue&type=script&lang=ts&"
import style0 from "./AddDiscount.vue?vue&type=style&index=0&id=aad078d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports